import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/customerprofile/`;

const addCustomerProfile = async (profile) => {
    return await axios.post(API_URL + 'create', profile);
};

const updateProfile = async (profile) => {
    console.log('start update')
    return await axios.put(API_URL , profile);
};

const updateProfileProductGroup = async (formData) => {
    return await axios.post(API_URL + 'updateprofilegroup' , formData);
};

const getBlacklistProfile = async (formData) => {
    return await axios.post(API_URL + 'blacklist', formData);
};

const getNewCustomerOrder = async (shop) => {
    return await axios.post(API_URL + 'newprofileorder', shop);
};

const getFollowProfile = async (formData) => {
    return await axios.post(API_URL + 'crm', formData);
};

const getVipProfile = async (formData) => {
    return await axios.post(API_URL + 'vip', formData);
};

const checkBlacklist = async (customerId) => {
    return await axios.post(API_URL + 'checkblacklist', {customerId});
};

const removeProfileFromBlacklist = async (customerId) => {
    return await axios.post(API_URL + 'blacklistclear', {customerId});
};

const addProfileToBlacklist = async (customerId) => {
    return await axios.post(API_URL + 'blacklistadd', {customerId});
};

const checkAndRemoveBlacklistIfNeeded = async (customerId) => {
    return await axios.post(API_URL + 'checkandremoveblacklist', {customerId});
};

const updateSendSameAddress = async (profile) => {
    return await axios.post(API_URL + 'updatesendsameaddress', profile);
};

const updateSocialId = async (profile) => {
    return await axios.post(API_URL + 'updatesocialid', profile);
};

const getCustomerDetails = async (customerId) => {
    return await axios.post(API_URL + 'crm/detail', {customerId});
};

const followCrm = async (formData) => {
    return await axios.post(API_URL + 'crm/follow', formData);
};

const createCustomerRateAdjustment = async (data) => {
    return await axios.post(API_URL + 'rate-adjustment', data);
};

const getCustomerRateAdjustments = async (customerId) => {
    return await axios.post(API_URL + `rate-adjustment/${customerId}`);
};

const updateCustomerRateAdjustment = async (data) => {
    return await axios.put(API_URL + 'rate-adjustment', data);
};

const seedFutureRateAdjustments = async (data) => {
    return await axios.post(API_URL + 'rate-adjustment/seed-future', data);
};

const getCustomerPaymentReceipts = async (payload) => {
    return await axios.post(API_URL + 'payment-receipts', payload);
};

const createPromoteLink = async (customerProfileId) => {
    return await axios.post(API_URL + 'promote-link', { customerProfileId });
};

const findProfileByPhone = async (phone, shop) => {
    return await axios.post(API_URL + 'byphone', { phone, shop });
};

const findProfileByContact = async (contact, shop) => {
    return await axios.post(API_URL + 'bycontact', { contact, shop });
};

const mergeAccounts = async (oldProfileId, newProfileId) => {
    return await axios.post(API_URL + 'merge', { oldProfileId, newProfileId });
};

// Price-negotiation quota: admin-set overrides + the customer's live slots
const getNegotiationQuota = async (customerId) => {
    return await axios.get(API_URL + `negotiation-quota/${customerId}`);
};

const updateNegotiationQuota = async (customerId, { negotiationLimit, negotiationUnlimited }) => {
    return await axios.put(API_URL + `negotiation-quota/${customerId}`, { negotiationLimit, negotiationUnlimited });
};

// Auction: can a win be charged to this customer's wallet + told on LINE? { ready, reason }
const getAuctionReadiness = async (customerId) => {
    return await axios.get(API_URL + `auction-readiness/${customerId}`);
};

// Generic change_logs reader (mounted at /api/changelog, not under customerprofile)
const getChangeLogs = async (entityType, entityId) => {
    return await axios.post(`${BACKEND_URL}/api/changelog/getlog`, { entityType, entityId });
};

export default {
    addCustomerProfile,
    updateProfile,
    updateSendSameAddress,
    updateSocialId,
    getBlacklistProfile,
    checkBlacklist,
    removeProfileFromBlacklist,
    addProfileToBlacklist,
    checkAndRemoveBlacklistIfNeeded,
    getVipProfile,
    getFollowProfile,
    getCustomerDetails,
    followCrm,
    getNewCustomerOrder,
    updateProfileProductGroup,
    createCustomerRateAdjustment,
    getCustomerRateAdjustments,
    updateCustomerRateAdjustment,
    seedFutureRateAdjustments,
    getCustomerPaymentReceipts,
    createPromoteLink,
    findProfileByPhone,
    findProfileByContact,
    mergeAccounts,
    getChangeLogs,
    getNegotiationQuota,
    updateNegotiationQuota,
    getAuctionReadiness,
};
